import Vue from 'vue'
import VueRouter from 'vue-router'
import PageArticle from '@/views/article/src/view/article/Article'

Vue.use(VueRouter)

const PageHome = resolve => require(['@/views/home/home.vue'], resolve)
const PageList = resolve => require(['@/views/list/list.vue'], resolve)
const PageGame = resolve => require(['@/views/game/game.vue'], resolve)

const routes = [
  { path: '/', name: 'home', component: PageHome },
  { name: 'article', path: '/article/:id(.*)', component: PageArticle, meta: { title: '' } },
  { name: 'list', path: '/list', component: PageList },
  { name: 'game', path: '/game', component: PageGame }
]

const router = new VueRouter({
  mode: 'history',
  base: '/zones/google/cloud',
  routes
})

router.afterEach((to, from) => {
  if (window.gtag) {
    // window.ga('set', 'page', to.fullPath)
    // window.ga('send', 'pageview')
    window.gtag('config', 'UA-103082599-11', { 'page_path': to.fullPath })
    window.gtag('config', 'UA-160408832-1', { 'page_path': to.fullPath })
    // gtag('event',  to.fullPath, { 'send_to': 'agency' });
  }
})

export default router
